export var SkeletonCssClass;
(function (SkeletonCssClass) {
    SkeletonCssClass["Base"] = "iress-skeleton";
    SkeletonCssClass["Bone"] = "iress-skeleton__bone";
    SkeletonCssClass["Lines"] = "iress-skeleton--lines";
})(SkeletonCssClass || (SkeletonCssClass = {}));
export var SkeletonMode;
(function (SkeletonMode) {
    SkeletonMode["Rect"] = "rect";
    SkeletonMode["Circle"] = "circle";
    SkeletonMode["Text"] = "text";
})(SkeletonMode || (SkeletonMode = {}));
//# sourceMappingURL=skeleton.types.js.map